import { StyledCaption, StyledFigure, StyledScreenshot } from '../styled-components'

interface HelpScreenshotProps {
  src: string
  alt: string
  caption?: string
}

const HelpScreenshot = ({ src, alt, caption = '' }: HelpScreenshotProps) => (
  <StyledFigure>
    <StyledScreenshot src={src} alt={alt} loading='lazy' />
    <StyledCaption hidden={!caption} dangerouslySetInnerHTML={{ __html: caption }} />
  </StyledFigure>
)

export default HelpScreenshot
